import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CContainer,
	CHeader,
	CHeaderDivider,
	CImage,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
	MyKalendercheck,
} from '../../components/index'
import { UFunc,cBulanPendek } from '../../helpers/functions'

const Headersubdashboard = (props) => {
	const { setToken,setLoading, showToast } = props 

	//--DOM--/
	const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction)
	const [uISTrigeringload,setTrigeringload] 	= React.useState(false);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uCabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]");
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const [uInitawal,setInitawal]			= React.useState(false);
	const [uInitloading,setInitloading]		= React.useState(false);
	const [uDataformObj,setDataformObj] 	= React.useState({});
	const uCabanguserArr			= uTokenObj.userhak==="FREEROLE"
		? uCabangArr : (uCabangArr.filter(vItems=>(uTokenObj.user_cabangarr||[]).includes(vItems.id)));

	React.useEffect(()=>{
		//console.log("(Headersubdashboard - []) LEWATs uInitloading",uInitloading)
		return () => {
			setInitloading(false);
			setInitawal(false);
			setTrigeringload(false);
		}
	},[])
	React.useEffect(()=>{
		if(!uISTrigeringload) return;

		setTrigeringload(false);
		const vHeaderTmpObj	= uHeaderActionObj;
		uDispatch({type: "set", gInitHeaderAction: {}});//-->HARUS_DIKOSONGIN_DULU_BIAR_ADA_EFFECT--/

		//---SAVE_KEYWORD--/
		uKeywordObj.filter_dashboard = uDataformObj;
    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
		//---END SAVE_KEYWORD--/

		vHeaderTmpObj.isHeaderView = true;
		uDispatch({type: "set", gInitHeaderAction: vHeaderTmpObj});
	},[uISTrigeringload])
	React.useEffect(()=>{
		if(uDataformObj.id_cabang===undefined) {
			setDataformObj({...uDataformObj,id_cabang:localStorage.getItem("lastcabangid")});
			return;
		}

		if(uDataformObj.tgl_filter===undefined) {
			const vTglNow	= new Date();
			setDataformObj({...uDataformObj, 
				tgl_filter: UFunc.DbDate(new Date(vTglNow.getFullYear(),
					vTglNow.getMonth(),1)),
			});

			setInitawal(true);
			return;
		}

		if(!uInitloading) return;
		setTrigeringload(true);
	},[
	uDataformObj.id_cabang,
	uDataformObj.tgl_filter
	])
	React.useEffect(()=>{
		if(!uInitawal) return;

		setInitloading(true);
	},[uInitawal])

	//console.log("Headersubdashboard - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<small>{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}</small>
		</div>
		
		<CForm className="d-flex">
			<Link onClick={()=>setTrigeringload(!uISTrigeringload)} className="d-none me-2 classcusrsorpointer classikon classikonreset"/>

				<MyKalendercheck height={35} isShowlink={true} isShowbadge={true} {...props}/>
				<span className="me-1"/>

			<CInputGroup size="sm" className="d-inline">
			{uCabangArr.length > 1 && (
			<>
			<CFormSelect size="sm"
				className="w-auto"
				value={uDataformObj.id_cabang}
				onChange={(e)=>setDataformObj({...uDataformObj,id_cabang:e.target.value})}
				id="inpcabangid">
				{uCabanguserArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{(vItems.cabang_nama||"").toUpperCase()}</option>
					)			
				})}
			</CFormSelect>
			<span className="me-1"/>
			</>
			)}

			<CFormSelect size="sm"
				className="w-auto"
				value={uDataformObj.tgl_filter}
				onChange={(e)=>setDataformObj({...uDataformObj,tgl_filter:e.target.value})}
				id="inpperiode">
				{[...new Array(6)].map((_,vKeys)=>{
					const vTglNow	= new Date();
					const vMonthidx	= vTglNow.getMonth() - vKeys < 0 
						? (vTglNow.getMonth() - vKeys) + 12 
						: vTglNow.getMonth() - vKeys;
					const vYear		= vTglNow.getMonth() - vKeys < 0 
						? vTglNow.getFullYear()-1 : vTglNow.getFullYear();//-*/

					const vTglsatu	= new Date(vYear,vMonthidx,1);
					const vValue 	= UFunc.DbDate(vTglsatu);
					const vCaption 	= (cBulanPendek[vMonthidx]||"").toUpperCase()+" "+vYear; 

					return (
					<option value={vValue} key={vKeys}>{vCaption}</option>
					)
				})}
				{/*(()=>{
					const vYear 	= 2021;
					const vMonthidx = 9;

					const vValue 	= 
						UFunc.DbDate(new Date(vYear,vMonthidx,1))
					const vCaption 	= (cBulanPendek[vMonthidx]||"").toUpperCase()+" "+vYear; 

					return (
					<option value={vValue}>{vCaption}</option>
					)
				})()*/}
			</CFormSelect>
			</CInputGroup>
		</CForm>
		</>
	)//>
}

export default Headersubdashboard
